import { BaseContainerModel } from '../../base-container.model';
import { bl_aat_claim_engagement_audit_trail_RowClass } from '../../../dbschema';

export class EngagementAuditTrailContainer extends BaseContainerModel {
  bl_aat_claim_engagement_audit_trail: bl_aat_claim_engagement_audit_trail_RowClass = new bl_aat_claim_engagement_audit_trail_RowClass();
}
